/* template */
<template minapp="mpx" xlang="wxml"><controllable-drawer-bottom :customStyle="(customStyle)" :headerStyle="(headerStyle)" :show="(show)" :useDefaultIcon="(false)" @close="closeDrawer"><mpx-image slot="close-icon" src="https://ut-static.udache.com/webx/sfc/v5Jr29yGXupbYCt1_5w8U.png" class="close-icon"/><div :style="[(computedContainerStyle)] | transRpxStyle" class="container"><div class="title"><mpx-image :src="(title)" mode="heightFix" class="name"/><div class="rights-desc">{{ rightsTitle }}</div></div><mpx-view @scroll="handleScroll" class="content"><Swiper itemSize="320" :swiperList="(swiperList)" @change="changeIndex" class="mb-28"/><div class="rule-wrapper"><div :style="[(showMoreStyle)] | transRpxStyle" ref="__mpx_ref_listref__" class="rule-text-list"><mpx-view @tap="showMoreFun" class="show-more" v-if="(showMoreBtn)">展开更多<spring-icon w="16" h="9" name="bottom-thin-arrow" class="bottom-thin-arrow"/></mpx-view><div class="rule-text-item">{{ ruleText[curIndex] }}</div></div></div></mpx-view><div class="footer" v-if="(!nofooter)"><div class="footer-content"><div class="footer-price"><div class="unit">¥</div><div class="ticket-price">{{ ticketPrice }}</div><div class="service-price">+¥{{ servicePrice }}退改无忧</div></div><mpx-view @tap="chooseRight" class="footer-btn">立即购买</mpx-view></div></div></div></controllable-drawer-bottom></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m67c7d014"}'>
  .mb-28
    margin-bottom 28px
    height 200px
    flex-shrink 0
  .bg-img
    width 100%
    position absolute
    top 0
    left 0
    z-index 1
  .close-icon
    height 28px
    width 28px
  .container
    height 100%
    z-index 2
    display flex
    justify-content flex-start
    flex-direction column
    box-sizing border-box
    overflow auto
    .title
      flex-shrink 0
      height 96px
      display flex
      flex-direction column
      align-items center
      padding-top 22px
      box-sizing border-box
      .name
        height 40px
      .rights-desc
        font-size 12px
        font-family PingFangSC-Medium
        font-weight 500
        color #FFFFFF
    .content
      flex 1
      height 0
      display flex
      flex-direction column
      align-items center
      overflow auto
      padding-bottom 8px
      box-sizing border-box
      .rule-wrapper
        width calc(100% - 32px)
        position relative
        box-sizing border-box
        padding 16px 12px
        border-radius 10px
        background #fef7f5
        color #666
        border 0.5px solid rgba(184, 112, 72, 0.3)
        &::before
          z-index 1
          content ''
          position absolute
          height 15px
          width 15px
          left 50%
          top 0
          transform translate(-50%, -50%) rotate(-45deg)
          background #fef7f5
          border 0.5px solid rgba(184, 112, 72, 0.3)
          border-left none
          border-bottom none
        .rule-text-list
          position relative
          font-size 12px
          line-height 17px
          overflow hidden
          transition max-height 0.3s ease-in-out
          .show-more
            z-index 1
            background #fef7f4
            position absolute
            bottom 0
            right 0
            display flex
            align-items center
            color #5F88C8
            &::after
              content ''
              position absolute
              bottom 0
              left 0
              width 12px
              height 100%
              background linear-gradient(to left, #fff, rgba(255, 255, 255, 0.1))
              z-index 2
              transform translateX(-100%)
            .bottom-thin-arrow
              margin-left 3px
          .rule-text-item
            display flex
            align-items flex-start
            white-space pre-line
    .footer
      margin-top 4px
      box-sizing border-box
      height 100px
      width 100%
      padding 11px 14px 39px 16px
      border-radius 10px 10px 0 0
      box-shadow inset 0px 1px 0px 0px #EEEEEE
      .footer-content
        display flex
        justify-content space-between
        align-items center
        .footer-price
          display flex
          align-items baseline
          .unit
            font-size 16px
            font-family PingFangSC-Semibold
            font-weight 600
            color #FF6400
            margin-right 1px
          .ticket-price
            font-family Barlow Semi Condensed
            font-size 32px
            line-height 32px
            font-weight 400
            color #FF6400
            margin-right 4px
          .service-price
            font-size 11px
            line-height 16px
            color #666
        .footer-btn
          border-radius 10px
          line-height 16px
          padding 17px 38px
          box-sizing border-box
          display flex
          justify-content center
          align-items center
          background #FF6400
          font-family PingFangSC-Medium
          font-weight 500
          color #fff
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m67c7d014"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./worry-free-cancellation-drawer.mpx.js?isComponent&outputPath=components%2Fworry-free-cancellation-drawer67c7d014%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./worry-free-cancellation-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fworry-free-cancellation-drawer67c7d014%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m67c7d014"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/worry-free-cancellation-drawer67c7d014/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'spring-icon':getComponent(require("../../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'controllable-drawer-bottom':getComponent(require("../../../components/controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex")),'Swiper':getComponent(require("../../../../node_modules/@didi/spring-ui/ts-web-swiper/index.mpx?isComponent&outputPath=components%2Findexf1757408%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
